import { push } from "connected-react-router";
import { put, takeEvery } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { UPDATE_TEMPLATE, UpdateTemplateAction, updateTemplateEnd } from "../actions";

export function* updateTemplate(action: UpdateTemplateAction) {
    const { payload } = action;
    const { template, selectOnSuccess } = payload;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.updateTemplate(template);
        const { app, intents } = result;

        yield put(updateTemplateEnd(undefined, app, intents));
        if (selectOnSuccess) {
            yield put(push(`/${app.organizationId}/${app.appId}`));
        }
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield updateTemplateEnd(e);
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchUpdateTemplate() {
    yield takeEvery(UPDATE_TEMPLATE, updateTemplate);
}
